// Import 3rd-party dependencies
import { Component, ViewChild, Renderer2, ElementRef, OnInit } from '@angular/core';

// Import project-specific dependencies
import { AnnouncementsService } from '@app/services/announcements/announcements.service';

@Component({
  selector: 'app-announcements',
  templateUrl: './announcement-banner.component.html',
  styleUrls: ['./announcement-banner.component.css']
})
export class AnnouncementBannerComponent implements OnInit {
  // Class attributes
  @ViewChild('announcementText') announcementText: ElementRef;
  @ViewChild('header') header: ElementRef;
  isClosed: boolean;

  latestAnnouncement$ = this.announcementsService.announcementList$;

  // Class methods
  constructor(private announcementsService: AnnouncementsService, private renderer: Renderer2) {}

  ngOnInit(): void {
    this.isClosed = false;
  }

  startScrollText(e: Event): void {
    const element = e.target as HTMLElement;
    if (element.offsetWidth < element.scrollWidth) {
      this.renderer.setStyle(element, 'overflow', 'visible');
      this.renderer.setStyle(element, 'animation-play-state', 'running');
    } else {
      this.renderer.setStyle(element, 'animation-play-state', 'paused');
    }
  }

  stopScrollText(e: Event): void {
    const element = e.target as HTMLElement;
    this.renderer.setStyle(element, 'overflow', 'hidden');
    this.renderer.setStyle(element, 'text-overflow', 'ellipsis');
    this.renderer.setStyle(element, 'white-space', 'nowrap');
    this.renderer.setStyle(element, 'animation-play-state', 'paused');
  }

  close(): void {
    this.isClosed = true;
    this.renderer.setStyle(this.header.nativeElement, 'margin-top', '60px');
  }
}
